import React from "react";
import styled, { css } from "styled-components";
import InnerHTML from 'dangerously-set-html-content'
import { getUrlVars } from "../../utility/get-url-vars";
import { getLocalCart, stringifyCart } from "../../utility/get-local-cart";
import { getItemVariation } from "../checkout/product-table-review";
import { useRenderedOnClient } from "../../../vicbooth/shared/hooks/use-rendered-on-client";

export const ckContentStyles = css`
  img { width: 100%; max-width: 100%; }
  h2, h3, h4, h5, p { color: black; }
  h1 { font-size: 42px; line-height: 100%; color: #ff3700; margin-bottom: 16px;}
  p {font-size: 16px; line-height: 150%; margin-bottom: 16px;}
  h2 {font-size: 30px; line-height: 100%; margin-bottom: 16px;}
  h3 {font-size: 24px; line-height: 100%; margin-bottom: 16px; font-weight: 700; margin-top: 24px;}
  h4 {font-size: 18px; line-height: 100%; margin-bottom: 8px; margin-top: 16px; font-weight: 700;}
  h5 {font-size: 16px; line-height: 125%; margin-bottom: 8px; font-weight: 700;}
  .small {font-size: 14px; line-height: 125%;}
  .highlight {font-size: 20px; line-height: 125%;}
  figure {margin: 0;}
  figure + figure { margin: 16px 0px; }
  & > figure {margin: 30px 0;}
  figure + p { margin-top: 16px; }
  h4 + figure {
    margin-top: 16px;
  }
  figcaption {
    font-size: 14px;
    margin-top: 8px;
    line-height: 150%;
    margin-bottom: 16px;
  }
  blockquote + h2,
  p + h2 { margin-top: 24px; }
  i:not([class*="fa-"]) { font-style: italic; }

  ol {
    list-style: decimal;
  }
  ul {
    list-style-type: "/ ";
  }
  ol, ul {
    padding-left: 16px;
    margin-bottom: 16px;
    line-height: 100%;
    font-size: 16px;
    color: black;
  }
  ul:not(.browser-default)>li {
    list-style-type: "/ ";
  }
  li {
    line-height: 150%;
    text-indent: 5px;
  }
  li::marker {
    font-weight: 700;
    color: #808080;
  }

  blockquote {
    margin: 20px 0;
    padding-left: 1.5rem;
    border-left: 5px solid #ed513b;
  }

  table {
    width: auto;
    color: black;
    line-height: 150%;
    font-size: 16px;
  }
  table tr:nth-child(even),
  table thead tr {
    background:#f8f8f8;
  }
  table tr td:not(:first-child),
  table tr th:not(:first-child) {
    text-align: center;
  }
  table td {
    padding: 15px 10px;
  }
  table.flexi-glue > tbody > *:nth-child(even) > *:not(:nth-last-child(n+3)) {
    background: #ddeee1;
  }
  table.flexi-glue > tbody > *:nth-child(odd) > *:not(:nth-last-child(n+3)) {
    background: #f2f9f4;
  }
  table p {
    margin-bottom: 7px;
    margin-top 7px;
  }

  div.content-grid {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 0px -12px;
  }
  div.content-grid > * {
    flex: 1 0 290px;
    margin: 12px;
  }
  .fa-check {
    color: #00ac54;
  }
  .fa-times {
    color: red;
  }
  .fa-circle-play {
    color: grey;
  }
  .fa-download {
    color: #1e9d8b;
  }
`

const HTMLContentDiv = styled.div`${ckContentStyles}`

const HTMLContent = (props) => {
  const { content } = props;
  const isRenderedOnClient = useRenderedOnClient()
  if (!content || !isRenderedOnClient) return null
  const urlVars = getUrlVars()
  const cart = getLocalCart()
  const replacedContent = content
    .replace('{{cart}}', encodeURIComponent(urlVars.cart ? urlVars.cart : stringifyCart(cart)))
    .replace(/{{(.+?)}}/g, (_, p1) => urlVars[p1] || '')

  return (
    <HTMLContentDiv>
      <InnerHTML html={replacedContent} />
    </HTMLContentDiv>
  );
};

export default HTMLContent;
